<template lang="html">
  <header id="header">
    <div class="header-menu">
      <b-navbar toggleable="lg" type="light" variant="light">
        <div class="container med-container">
          <b-navbar-brand to="/">
            <img src="public/images/logo.svg">
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"><i class="fa-light fa-bars"></i></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="mx-auto">
              <b-nav-item class="simple-item" to="/#/" v-scroll-to="'#e-c'">Características</b-nav-item>
              <b-nav-item class="simple-item" to="/#/" v-scroll-to="'#e-b'">Beneficios</b-nav-item>
              <b-nav-item class="simple-item" to="/#/" v-scroll-to="'#e-f'">Registro</b-nav-item>
            </b-navbar-nav>

            <b-navbar-nav class="ml-auto navbar-btn">
              <router-link class="btn btn-s1 bg-1" to="/login">Iniciar sesión</router-link>
            </b-navbar-nav>
          </b-collapse>
        </div>
      </b-navbar>
    </div>
  </header>
</template>

<script>
export default {
}
</script>
